<template>
  <crud-update :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @update="update"
               @close="$emit('close')"
  >
    <agencia-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-update>
</template>

<script>

import AgenciaProvider from "../../../../providers/AgenciaProvider";

import {CrudUpdate, ClientError} from '@dracul/common-frontend'

import AgenciaForm from "../AgenciaForm";


export default {
  name: "AgenciaUpdate",

  components: {AgenciaForm, CrudUpdate},

  props: {
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },

  data() {
    return {
      title: 'cobrox.agencia.editing',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      id: this.item.id,
      form: {
        nombre: this.item.nombre,
        telefonoDerivaciones: this.item.telefonoDerivaciones,
        telefonoConsultas: this.item.telefonoConsultas,
        mail: this.item.mail,
        horario_atencion: this.item.horario_atencion,
        observacion: this.item.observacion,
        usuarios: this.item.usuarios ? this.item.usuarios.map(u => u.id) : [],
        derivarDefault: this.item.derivarDefault ? this.item.derivarDefault : null,
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        this.loading = true
        AgenciaProvider.updateAgencia(this.id, this.form).then(r => {
              if (r) {
                this.$emit('itemUpdated', r.data.updateAgencia)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }
  },
}
</script>

<style scoped>

</style>

